var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"tag-box",style:({backgroundColor:_vm.findObj.color})},[_c('div',{staticClass:"content"},[_vm._v(" "+_vm._s(_vm.findObj.label)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }